import { useState, useEffect, useCallback } from 'react';
import { decriptValueFromEncryptedString } from './helpers';

interface DecryptionCache {
  [key: string]: string;
}

export const useDecryption = () => {
  const [cache, setCache] = useState<DecryptionCache>({});

  const decryptValue = useCallback(
    async (encryptedString: string, showFullValue = false): Promise<string> => {
      const cacheKey = `${encryptedString}_${showFullValue}`;

      if (cache[cacheKey]) {
        return cache[cacheKey];
      }

      try {
        const decrypted = await decriptValueFromEncryptedString({
          encryptedString,
          showFullValue,
        });

        setCache((prev) => ({
          ...prev,
          [cacheKey]: decrypted,
        }));

        return decrypted;
      } catch (error) {
        console.error('Decryption error:', error);
        return '';
      }
    },
    []
  );

  const clearCache = useCallback(() => {
    setCache({});
  }, []);

  return { decryptValue, clearCache };
};
